/**
 * Created by alvinoktavianus on 6/22/17.
 */

import { BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION } from './constant';

export function showBillingNotification(billingNotification) {
  return {
    type: BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION,
    payload: { billingNotification },
  };
}
